import { ref } from 'vue'
import { useApi } from '@/api/useApi'
import API from '@/api/apiUrls'
import { defineStore } from 'pinia'
import type { UserType } from '@/stores/type/authDjango.type'

const { api } = useApi()
const currentUser = API.CORE.USERS.CURRENT_USER

interface ClientPrincipal {
  userId: string
  userDetails: string
  identityProvider: string
  userRoles: string[]
}

async function getClientPrincipal(): Promise<ClientPrincipal | null> {
  try {
    const res = await fetch('/.auth/me')
    if (!res.ok) return null
    const body = (await res.json()) as { clientPrincipal: ClientPrincipal | null }
    return body.clientPrincipal ?? null
  } catch {
    return null
  }
}

export const useAuthenticationStore = defineStore('auth', () => {
  const user = ref<UserType | null>(null)
  const hasInitialized = ref(false)

  async function reAuthenticate() {
    try {
      const principal = await getClientPrincipal()
      if (!principal) throw new Error('no client principal')
      user.value = await api.service(currentUser).get()
    } catch {
      user.value = null
    }
    hasInitialized.value = true
    return { user: user.value }
  }

  function login(redirect = window.location.pathname + window.location.search) {
    window.location.href = `/.auth/login/aad?post_login_redirect_uri=${encodeURIComponent(redirect)}`
  }

  function logout() {
    user.value = null
    window.location.href = '/.auth/logout'
  }

  return {
    user,
    hasInitialized,
    reAuthenticate,
    login,
    logout
  }
})
